// App.tsx
import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import AlertContainer from './components/Alert';
import Home from './pages/Home';
import About from './pages/About';
import ProductsPage from './pages/ProductsPage';
import ProductPage from './pages/ProductPage';
import ShoppingCart from './pages/ShoppingCart';
import PaymentPage from './pages/PaymentPage';
import CheckoutResultPage from './pages/CheckoutResultPage';
import SellerHome from './pages/Seller/SellerHome';
import Login from './components/login/Login';
import ForgotPassword from './components/login/ForgotPassword';
import ResetPassword from './components/login/ResetPassword';
import Signup from './components/signunp/Signup';
import BrandsPage from './pages/BrandsPage';
import UserPage from './pages/User/UserPage';
import NavBar from './components/Navbar';
import { ProtectedRoute } from './components/ProtectedRoute';
import StoreDetailPage from './pages/StoreDetailPage';
import StoreAdminPage from './pages/Seller/StoreAdminPage';
import Footer from './components/Footer';

const stripePromise = loadStripe(
  'pk_test_51OisEFJp3TLgm0DXNLyqxxi81S3zvnpklFhiZAbe3HlVQAKQJp3p8BbTF5PvtkLzintB07wcMgbqngUyAzts5bQe00XbBVcCnn'
);

const HomeRoute: React.FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  if (params.has('session_id')) {
    return <Navigate to={`/checkout/success${location.search}`} replace />;
  }

  return <Home />;
};

const App: React.FC = () => (
  <>
    {/* global alert container */}
    <AlertContainer />

    <Router>
      {/* your navbar (with AccountDropdown) always at the top */}
      <NavBar />

      <Routes>
        <Route path="/" element={<HomeRoute />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/product/:id" element={<ProductPage />} />
        <Route
          path="/shopping-bag"
          element={
            <ProtectedRoute>
              <ShoppingCart />
            </ProtectedRoute>
          }
        />
        {/* Only wrap the checkout page in Stripe’s <Elements> */}
        <Route
          path="/checkout"
          element={
            <Elements stripe={stripePromise}>
              <PaymentPage />
            </Elements>
          }
        />
        <Route
          path="/checkout/success"
          element={<CheckoutResultPage status="success" />}
        />
        <Route
          path="/checkout/success/:orderId"
          element={<CheckoutResultPage status="success" />}
        />
        <Route
          path="/checkout/cancel"
          element={<CheckoutResultPage status="cancel" />}
        />
        <Route path="/seller-home" element={<SellerHome />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/storePage" element={<BrandsPage />} />
        <Route path="/store/:storeId" element={<StoreDetailPage />} />

        {/*
          Add the Store Admin page.
          You’ll probably want to protect it so only store-owners/admins can see it,
          e.g. wrap in your ProtectedRoute or another guard.
        */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <StoreAdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user"
          element={
            <ProtectedRoute>
              <UserPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
    <Footer />
  </>
);

export default App;
